import {
    TBuyerFinalOffer,
    TBuyerOfferSession,
    TBuyerDetails,
} from '@pb/apps/offers/services/buyer-offer-session';
import { getDateFromString } from '@pb/apps/offers/helpers/formatters';

export const mapBuyerOfferSessionDataToFinalOffer = (
    offerSessionData: TBuyerOfferSession
): TBuyerFinalOffer => {
    const isPurplePactApplicable = offerSessionData?.isPurplePactApplicable;
    const dealProtectBuyer = isPurplePactApplicable
        ? offerSessionData?.buyerAdditionalDetails?.isInterestedInPurplePact
        : null;

    const buyers: TBuyerDetails[] = offerSessionData.buyers.map(buyer => {
        const dateOfBirth = buyer.dateOfBirth ?? '';
        return {
            id: buyer.id,
            addressLine1: buyer.addressLine1,
            addressLine2: buyer.addressLine2,
            county: buyer.county,
            email: buyer.email,
            forename: buyer.forename,
            middlename: buyer.middlename,
            surname: buyer.surname,
            name: buyer.name,
            offerId: buyer.offerId,
            phone: buyer.phone,
            postCode: buyer.postCode,
            town: buyer.town,
            usePrimary: buyer.usePrimary,
            addressId: buyer.addressId,
            dateOfBirth: getDateFromString(dateOfBirth),
        };
    });

    return {
        propertyId: offerSessionData.propertyId,
        buyerAdditionalDetails: offerSessionData.buyerAdditionalDetails,
        buyers: buyers,
        comment: offerSessionData.comment,
        homeserveOfferDetails: offerSessionData.homeserveOfferDetails,
        offerAmount: offerSessionData.offerAmount,
        dealProtectBuyer,
    };
};
